<template>
  <div class="fenxiao-center">
    <!-- 页面头部 -->
    <div class="page-header">
      <el-button type="text" @click="goBack" class="back-btn">
        <i class="el-icon-arrow-left"></i>
        返回
      </el-button>
      <h2 class="page-title">{{ fenxiaoWords.concept }}中心</h2>
    </div>

    <div class="center-container" v-if="info.fenxiao_name">
      <!-- 推广员信息卡片 -->
      <div class="fenxiao-info-card">
        <div class="info-header">
          <div class="avatar-section">
            <img 
              :src="info.headimg ? $util.img(info.headimg) : $util.img('/upload/default/default_img/head.png')"
              alt="头像"
              class="avatar"
            >
          </div>
          <div class="info-section">
            <div class="name-level" @click="goToLevel">
              <span class="name">{{ info.fenxiao_name }}</span>
              <span class="level">{{ info.level_name }}</span>
            </div>
            <div class="recommend">推荐人：{{ info.parent_name || '无' }}</div>
          </div>
          <div class="qr-section">
            <el-button type="text" @click="goToPromoteCode" class="qr-btn">
              推广链接
            </el-button>
          </div>
        </div>

        <!-- 佣金统计 -->
        <div class="commission-stats">
          <div class="stat-item" @click="goToBill">
            <div class="stat-value">{{ info.total_commission }}</div>
            <div class="stat-label">累计佣金 (元)</div>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item" @click="goToWithdrawList">
            <div class="stat-value">{{ info.account_withdraw }}</div>
            <div class="stat-label">累计提现 (元)</div>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-item" @click="goToWithdrawList">
            <div class="stat-value">{{ info.account_withdraw_apply }}</div>
            <div class="stat-label">{{ fenxiaoWords.withdraw }}中 (元)</div>
          </div>
        </div>
      </div>

      <!-- 可提现佣金卡片 -->
      <div class="withdraw-card">
        <div class="withdraw-header">
          <div class="withdraw-info">
            <div class="withdraw-amount">{{ info.account }}</div>
            <div class="withdraw-label">可{{ fenxiaoWords.withdraw }} (元)</div>
          </div>
          <el-button type="primary" @click="goToWithdrawApply" class="withdraw-btn">
            申请提现
          </el-button>
        </div>
        <div class="withdraw-divider"></div>
        <div class="withdraw-stats">
          <div class="today-income">
            <div class="income-value">{{ info.today_commission }}</div>
            <div class="income-label">今日收入 (元)</div>
          </div>
          <div class="total-sales">
            <div class="sales-value">{{ info.today_order_money }}</div>
            <div class="sales-label">总销售额 (元)</div>
          </div>
        </div>
      </div>

      <!-- 团队统计卡片 -->
      <div class="team-stats-card">
        <div class="team-item" @click="goToTeam(1)">
          <div class="team-icon">
            <img :src="$util.img('upload/uniapp/fenxiao/index/team2.png')" alt="推荐供应商" />
          </div>
          <div class="team-info">
            <div class="team-title">推荐供应商</div>
            <div class="team-count">{{ info.supplier_num }}人</div>
          </div>
        </div>
        <div class="team-item" @click="goToTeam(0)">
          <div class="team-icon">
            <img :src="$util.img('upload/uniapp/fenxiao/index/member.png')" alt="推荐采购商" />
          </div>
          <div class="team-info">
            <div class="team-title">推荐采购商</div>
            <div class="team-count">{{ info.purchaser_num }}人</div>
          </div>
        </div>
      </div>

      <!-- 功能菜单 -->
      <div class="function-menu">
        <div class="menu-grid">
          <div class="menu-item" @click="goToWithdrawApply">
            <div class="menu-icon">
              <img :src="$util.img('upload/uniapp/fenxiao/index/withdraw.png')" alt="提现" />
            </div>
            <div class="menu-text">{{ fenxiaoWords.withdraw }}</div>
          </div>
          <div class="menu-item" @click="goToWithdrawList">
            <div class="menu-icon">
              <img :src="$util.img('upload/uniapp/fenxiao/index/tixian.png')" alt="提现明细" />
            </div>
            <div class="menu-text">{{ fenxiaoWords.withdraw }}明细</div>
          </div>
          <div class="menu-item" @click="goToOrder">
            <div class="menu-icon">
              <img :src="$util.img('upload/uniapp/fenxiao/index/order.png')" alt="推广订单" />
            </div>
            <div class="menu-text">{{ fenxiaoWords.concept }}订单</div>
          </div>
          <div class="menu-item" @click="goToBill">
            <div class="menu-icon">
              <img :src="$util.img('upload/uniapp/fenxiao/index/bill.png')" alt="佣金记录" />
            </div>
            <div class="menu-text">佣金记录</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 非推广员状态 -->
    <div class="not-fenxiao" v-else>
      <div class="empty-content">
        <p class="empty-text">您还不是{{ fenxiaoWords.fenxiao_name }}，请先提交申请</p>
        <el-button type="primary" @click="goToApply" class="apply-btn">
          立即加入
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getFenxiaoDetail, getFenxiaoTeamNum, getCommissionList, applyWithdraw, getWithdrawList, getPromoteLink, getPromoteQrcode } from '@/api/fenxiao'
import { mapGetters } from 'vuex'

export default {
  name: 'FenxiaoCenter',
  computed: {
    ...mapGetters(['member'])
  },
  data() {
    return {
      // 推广员信息
      info: {
        fenxiao_name: '',
        headimg: '',
        level_name: '',
        parent_name: '',
        total_commission: '0.00',
        account_withdraw: '0.00',
        account_withdraw_apply: '0.00',
        account: '0.00',
        today_commission: '0.00',
        today_order_money: '0.00',
        supplier_num: 0,
        purchaser_num: 0,
        status: 0
      },
      teamNum: 0,
      // 分销词汇
      fenxiaoWords: {
        fenxiao_name: '推广员',
        withdraw: '提现',
        concept: '推广',
        my_team: '我的团队'
      }
    }
  },
  created() {
    this.initPage()
  },
  methods: {
    // 初始化页面
    async initPage() {
      try {
        await this.getFenxiaoDetail()
        if (this.info.fenxiao_name) {
          await this.getTeamNum()
        }
      } catch (error) {
        console.error('页面初始化失败:', error)
      }
    },

    // 返回上一页
    goBack() {
      this.$router.go(-1)
    },

    // 获取推广员详情
    async getFenxiaoDetail() {
      try {
        const res = await getFenxiaoDetail()
        if (res.data) {
          this.info = res.data
        } else {
          // 未开通推广员，跳转到申请页
          this.$router.replace('/member/fenxiao_apply')
        }
      } catch (error) {
        console.error('获取推广员详情失败:', error)
      }
    },

    // 获取团队数量
    async getTeamNum() {
      try {
        const res = await getFenxiaoTeamNum()
        if (res.code >= 0) {
          this.teamNum = res.data
        }
      } catch (error) {
        console.error('获取团队数量失败:', error)
      }
    },

    // 检查账户状态
    checkAccountStatus() {
      if (this.info.status == -1) {
        this.$message.warning('您的账户已被冻结')
        return false
      }
      return true
    },

    // 跳转到等级页面
    goToLevel() {
      if (!this.checkAccountStatus()) return
      this.$router.push('/member/fenxiao_level')
    },

    // 跳转到推广码页面
    goToPromoteCode() {
      if (!this.checkAccountStatus()) return
      
      // 获取当前登录用户的 member_id
      const memberId = this.member && this.member.member_id ? this.member.member_id : null
      
      if (!memberId) {
        this.$message.warning('获取用户信息失败，请重新登录')
        return
      }
      
      // 获取网站根目录并拼接 suid 参数
      const baseUrl = window.location.origin
      const promoteUrl = `${baseUrl}/web/?suid=${memberId}`
      
      // 在新窗口中打开推广链接
      window.open(promoteUrl, '_blank')
    },

    // 跳转到佣金记录
    goToBill() {
      if (!this.checkAccountStatus()) return
      this.$router.push('/member/fenxiao_bill')
    },

    // 跳转到提现列表
    goToWithdrawList() {
      if (!this.checkAccountStatus()) return
      this.$router.push('/member/fenxiao_withdraw_list')
    },

    // 跳转到申请提现
    goToWithdrawApply() {
      if (!this.checkAccountStatus()) return
      this.$router.push('/member/fenxiao_withdraw_apply')
    },

    // 跳转到团队页面
    goToTeam(type) {
      if (!this.checkAccountStatus()) return
      this.$router.push(`/member/fenxiao_team?type=${type}`)
    },

    // 跳转到订单页面
    goToOrder() {
      if (!this.checkAccountStatus()) return
      this.$router.push('/member/fenxiao_order')
    },

    // 跳转到申请页面
    goToApply() {
      this.$router.push('/member/fenxiao_apply')
    }
  }
}
</script>

<style lang="scss" scoped>
.fenxiao-center {
  min-height: 100vh;
  background-color: #f5f5f5;

  .page-header {
    background: #fff;
    padding: 20px;
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    align-items: center;

    .back-btn {
      margin-right: 20px;
      font-size: 16px;
    }

    .page-title {
      margin: 0;
      font-size: 20px;
      font-weight: 600;
    }
  }

  .center-container {
    max-width: 1200px;
    margin: 20px auto;
    padding: 0 20px;
  }

  .fenxiao-info-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    padding: 30px;
    margin-bottom: 20px;
    color: #fff;

    .info-header {
      display: flex;
      align-items: center;
      margin-bottom: 30px;

      .avatar-section {
        margin-right: 20px;

        .avatar {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          border: 3px solid rgba(255, 255, 255, 0.3);
        }
      }

      .info-section {
        flex: 1;

        .name-level {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          cursor: pointer;

          .name {
            font-size: 20px;
            font-weight: 600;
            margin-right: 15px;
          }

          .level {
            background: rgba(255, 255, 255, 0.2);
            padding: 4px 12px;
            border-radius: 15px;
            font-size: 12px;
            border: 1px solid rgba(255, 255, 255, 0.3);
          }
        }

        .recommend {
          font-size: 14px;
          opacity: 0.9;
        }
      }

      .qr-section {
        .qr-btn {
          color: #fff;
          font-size: 16px;
          
          i {
            margin-right: 5px;
          }
        }
      }
    }

    .commission-stats {
      display: flex;
      align-items: center;

      .stat-item {
        flex: 1;
        text-align: center;
        cursor: pointer;
        transition: transform 0.2s;

        &:hover {
          transform: translateY(-2px);
        }

        .stat-value {
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 5px;
        }

        .stat-label {
          font-size: 14px;
          opacity: 0.9;
        }
      }

      .stat-divider {
        width: 1px;
        height: 40px;
        background: rgba(255, 255, 255, 0.3);
        margin: 0 20px;
      }
    }
  }

  .withdraw-card {
    background: #fff;
    border-radius: 12px;
    padding: 25px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

    .withdraw-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      .withdraw-info {
        .withdraw-amount {
          font-size: 28px;
          font-weight: 600;
          color: #409eff;
          margin-bottom: 5px;
        }

        .withdraw-label {
          font-size: 14px;
          color: #666;
        }
      }

      .withdraw-btn {
        padding: 12px 30px;
        border-radius: 25px;
      }
    }

    .withdraw-divider {
      height: 1px;
      background: #f0f0f0;
      margin-bottom: 20px;
    }

    .withdraw-stats {
      display: flex;

      .today-income,
      .total-sales {
        flex: 1;

        .income-value,
        .sales-value {
          font-size: 20px;
          font-weight: 600;
          color: #333;
          margin-bottom: 5px;
        }

        .income-label,
        .sales-label {
          font-size: 14px;
          color: #666;
        }
      }
    }
  }

  .team-stats-card {
    background: #fff;
    border-radius: 12px;
    padding: 20px 0px 20px 92px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    display: flex;
    gap: 30px;

    .team-item {
      flex: 1;
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: transform 0.2s;

      &:hover {
        transform: translateY(-2px);
      }

      .team-icon {
        width: 60px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 15px;

        img {
          width: 60px;
          height: 60px;
        }

        i {
          font-size: 24px;
          color: #fff;
        }
      }

      .team-info {
        .team-title {
          font-size: 16px;
          color: #333;
          margin-bottom: 5px;
        }

        .team-count {
          font-size: 14px;
          color: #666;
        }
      }
    }
  }

  .function-menu {
    background: #fff;
    border-radius: 12px;
    padding: 25px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

    .menu-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 20px;

      .menu-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          background: #f8f9ff;
          transform: translateY(-2px);
        }

        .menu-icon {
          width: 50px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 10px;

          img {
            width: 50px;
            height: 50px;
          }

          i {
            font-size: 20px;
            color: #fff;
          }
        }

        .menu-text {
          font-size: 14px;
          color: #333;
        }
      }
    }
  }

  .not-fenxiao {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 60vh;

    .empty-content {
      text-align: center;
      background: #fff;
      border-radius: 12px;
      padding: 60px 40px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

      .empty-icon {
        width: 150px;
        height: 150px;
        margin-bottom: 30px;
      }

      .empty-text {
        font-size: 16px;
        color: #666;
        margin-bottom: 30px;
      }

      .apply-btn {
        padding: 12px 40px;
        border-radius: 25px;
      }
    }
  }
}

// 响应式设计
@media (max-width: 1024px) {
  .fenxiao-center {
    .function-menu .menu-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    .team-stats-card {
      flex-direction: column;
      gap: 20px;
    }
  }
}

@media (max-width: 768px) {
  .fenxiao-center {
    .center-container {
      margin: 10px;
      padding: 0 10px;
    }

    .fenxiao-info-card {
      padding: 20px;

      .info-header {
        flex-direction: column;
        text-align: center;

        .avatar-section {
          margin-right: 0;
          margin-bottom: 15px;
        }

        .info-section {
          margin-bottom: 15px;
        }
      }

      .commission-stats {
        flex-direction: column;
        gap: 15px;

        .stat-divider {
          width: 100%;
          height: 1px;
          margin: 0;
        }
      }
    }

    .withdraw-card {
      padding: 20px;

      .withdraw-header {
        flex-direction: column;
        gap: 15px;
        text-align: center;
      }

      .withdraw-stats {
        flex-direction: column;
        gap: 15px;
        text-align: center;
      }
    }

    .function-menu .menu-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 15px;

      .menu-item {
        padding: 15px;
      }
    }
  }
}
</style>